// Mock data pour Foulées Vertes

export const siteSettings = {
  contact: {
    phone: '+33 4 73 17 06 13',
    phoneDisplay: '04 73 17 06 13',
    email: 'foulees.vertes@orange.fr',
    address: '6 rue du Puits Artésien, 63000 Clermont-Ferrand, France'
  },
  hours: {
    monday: { open: '15:00', close: '19:00', display: '15h - 19h' },
    tuesday: { open: '10:00', close: '19:00', display: '10h - 13h / 14h - 19h', break: true },
    wednesday: { open: '10:00', close: '19:00', display: '10h - 13h / 14h - 19h', break: true },
    thursday: { open: '10:00', close: '19:00', display: '10h - 13h / 14h - 19h', break: true },
    friday: { open: '10:00', close: '19:00', display: '10h - 13h / 14h - 19h', break: true },
    saturday: { open: '10:00', close: '19:00', display: '10h - 13h / 14h - 19h', break: true },
    sunday: { open: '14:00', close: '18:00', display: '14h - 18h*', note: 'Ouvertures ponctuelles' }
  },
  social: {
    facebook: 'https://facebook.com/fouleesvertes',
    instagram: 'https://instagram.com/fouleesvertes',
    strava: 'https://strava.com/clubs/fouleesvertes'
  }
};

export const teamMembers = [
  {
    id: '1',
    name: 'Karim',
    nickname: '🏃‍♂️ Le patron !',
    role: 'Fondateur',
    bio: "Mordu par le virus du running depuis plus de 40 ans (aucun vaccin en vue !), Karim fait ses classes sur les pistes du LOU en 1985. Rapidement, son amour de la nature le pousse à quitter le tartan pour les chemins, là où l'endurance devient un art de vivre. Paris Gao Dakar, SaintéLyon, et pas moins de huit éditions du mythique Marathon des Sables — son palmarès sent bon la poussière, l'aventure et le dépassement de soi. Et comme il aime finir ce qu'il commence, il s'offre en 2015 un Ironman à Embrun pour couronner le tout. Depuis, une cheville capricieuse l'oblige à lever (un peu) le pied… mais ses conseils, eux, restent affûtés comme à ses plus belles années ! Son plus grand plaisir : partager sa passion et faire en sorte que son expérience profite à tous !",
    photo: '/assets/images/team-karim.jpg'
  },
  {
    id: '2',
    name: 'Clément',
    nickname: '🏊‍♂️ Le nageur reconverti !',
    role: 'Conseiller Expert',
    bio: "Plutôt poisson que coureur à la base, il a vite été séduit par l'approche humaine et bienveillante de Karim. Ici, pas de business à tout prix : du conseil, de l'accompagnement et du partage avant tout ! Et comme les passions sont visiblement contagieuses, il s'est retrouvé — à sa grande surprise — à apprécier ses premières sorties sous la pluie, baskets aux pieds et sourire aux lèvres. Qui l'aurait cru ? Comme quoi, tout est possible avec la bonne équipe ! Aujourd'hui, Clément touche à tout : triathlon, course à pied… et même un peu de water-polo (on ne se refait pas) ! Toujours partant pour vous accompagner avec bonne humeur et énergie.",
    photo: '/assets/images/team-nico.jpg'
  },
  {
    id: '3',
    name: 'Cloé',
    nickname: "L'Alternante Passionnée",
    role: 'Conseillère',
    bio: "Passionnée de course à pied depuis toujours, elle a d'abord pratiqué la natation avant de se tourner vers l'athlétisme en 2021. Après avoir découvert le sprint, elle trouve rapidement sa voie dans le demi-fond, notamment à travers les cross l'hiver et le 1500/3000 m sur piste l'été. Aujourd'hui, elle aime varier les plaisirs entre la route, avec une affection particulière pour le 5 km, et le trail durant la saison estivale. Animée par le partage et la passion, elle prend plaisir à accompagner chaque coureur avec écoute, enthousiasme et des conseils adaptés à ses objectifs.",
    photo: '/assets/images/team-chloe.jpg'
  }
];

export const events = [
  {
    id: '1',
    name: 'Grand Trail d\'Auvergne',
    description: 'Le trail majeur de la région, au cœur des volcans.',
    date: '2025-06-15',
    location: 'Puy-de-Dôme',
    type: 'course_partenaire',
    image: 'https://images.unsplash.com/photo-1644285847952-927287137349?w=600&h=400&fit=crop'
  },
  {
    id: '2',
    name: 'Courir à Ladoux',
    description: 'Course locale conviviale pour tous les niveaux.',
    date: '2025-04-20',
    location: 'Ladoux',
    type: 'course_partenaire',
    image: 'https://images.pexels.com/photos/1194235/pexels-photo-1194235.jpeg?w=600&h=400&fit=crop'
  },
  {
    id: '3',
    name: 'La Ronde des Aulnes',
    description: 'Parcours nature à travers les forêts auvergnates.',
    date: '2025-09-12',
    location: 'Auvergne',
    type: 'course_partenaire',
    image: 'https://images.pexels.com/photos/554609/pexels-photo-554609.jpeg?w=600&h=400&fit=crop'
  }
];

export const brands = {
  chaussures: [
    {
      name: 'BROOKS',
      logo: '/assets/images/brands/brooks.png',
      logoScale: 1,
      models: ['Adrénaline GTS', 'Caldera', 'Cascadia', 'Cascadia Elite', 'Catamount', 'Defiance', 'Divide', 'Ghost', 'Ghost MAX', 'Ghost Trail', 'Glycerin', 'Glycerin GTS', 'Glycerin MAX', 'Hyperion MAX']
    },
    {
      name: 'HOKA',
      logo: '/assets/images/brands/hoka.png',
      logoScale: 1,
      models: ['Arahi', 'Bondi', 'Challenger', 'Clifton', 'Gaviota', 'Mach X', 'Speedgoat']
    },
    {
      name: 'RUN ON CLOUDS',
      logo: '/assets/images/brands/on.png',
      logoScale: 1.8,
      models: ['Cloud Monster', 'Cloud Runner', 'Cloud Surfer', 'Cloud Surfer Trail', 'Cloud SurferMax', 'Cloud SurferNext', 'Cloud Ultra', 'Cloud Vista']
    },
    {
      name: 'MIZUNO',
      logo: '/assets/images/brands/mizuno.png',
      logoScale: 1.6,
      models: ['Horizon', 'Neo Vista', 'Neo Zen', 'Paradox', 'Rider TT', 'Sky', 'Sky Rise', 'Wave Daichi', 'Wave Inspire', 'Wave Mujin', 'Wave Rider', 'Wave Ultima']
    },
    {
      name: 'SAUCONY',
      logo: '/assets/images/brands/saucony.png',
      logoScale: 1,
      models: ['Endorphine Speed', 'Guide', 'Hurricane', 'Kinvara', 'Peregrine', 'Ride', 'Ride TR', 'Triumph', 'Xodus Ultra']
    },
    {
      name: 'ASICS',
      logo: '/assets/images/brands/asics.png',
      logoScale: 1.8,
      models: ['Cumulus', 'Fuji Lite', 'Magic Speed', 'Nimbus', 'Noosa Tri', 'Novablast', 'Sonic Blast', 'Trabuco', 'Trabuco MAX']
    },
    {
      name: 'DIADORA',
      logo: '/assets/images/brands/diadora.png',
      logoScale: 1,
      models: ['Atomo Star', 'Nucleo', 'Nucleo GR', 'Volo']
    },
    {
      name: 'ROSSIGNOL',
      logo: '/assets/images/brands/rossignol.png',
      logoScale: 1,
      models: ['Venosk', 'Vezor']
    },
    {
      name: 'SALOMON',
      logo: '/assets/images/brands/salomon.png',
      logoScale: 1.6,
      models: ['Aero Glide', 'Genesis', 'S Lab Genesis', 'Ultra Glide']
    },
    {
      name: 'LA SPORTIVA',
      logo: '/assets/images/brands/la-sportiva.png',
      logoScale: 1.8,
      models: ['Akasha', 'Bushido', 'Jackal', 'Ultra Raptor']
    },
    {
      name: 'MERRELL',
      logo: '/assets/images/brands/merrell.png',
      logoScale: 1,
      models: ['Agility Peak', 'MTL Long Sky', 'Promorph']
    }
  ],
  textile: [
    { name: 'ODLO', models: ['Gamme Running', 'Base Layer'] },
    { name: 'CRAFT', models: ['Active Extreme', 'Pro'] },
    { name: 'SALOMON', models: ['S/Lab', 'Agile'] },
    { name: 'COMPRESSPORT', models: ['Racing', 'Training'] }
  ],
  accessoires: [
    { name: 'GARMIN', models: ['Forerunner', 'Fenix'] },
    { name: 'SUUNTO', models: ['Suunto 9', 'Vertical'] },
    { name: 'CAMELBAK', models: ['Ultra Pro', 'Nano'] },
    { name: 'BLACK DIAMOND', models: ['Lampes frontales'] }
  ],
  nutrition: [
    { name: 'MAURTEN', models: ['Gel 100', 'Drink Mix'] },
    { name: 'NÄAK', models: ['Ultra Energy', 'Bars'] },
    { name: 'OVERSTIM.S', models: ['Hydrixir', 'Gel Antioxydant'] },
    { name: 'APTONIA', models: ['Gamme Energy'] }
  ]
};

export const labSteps = [
  {
    number: 1,
    title: 'Parlez-nous de vous',
    description: 'Avant tout, on prend le temps de discuter ! Chaque coureur est différent : quels sont vos habitudes, vos sensations, vos objectifs… tout compte. L\'usure de vos anciennes chaussures est également passée au peigne fin. Cette conversation personnalisée nous permet de comprendre vos besoins réels et de vous conseiller le matériel qui vous correspond.'
  },
  {
    number: 2,
    title: 'Vos pieds ont aussi des choses à dire !',
    description: 'Maintenant que nous avons appris à vous connaître, la morphologie de vos pieds et de votre foulée entre en jeu. Notre piste de 25m équipée de la technologie footScan nous permet de les visualiser suite à un passage pied nu sur la piste, en marchant puis en courant.'
  },
  {
    number: 3,
    title: 'La chaussure',
    description: 'Après analyse, votre conseiller sélectionne différents modèles parmi des dizaines de références. Du 35 au 50, parmi les grands noms du running mais aussi des marques spécialisées moins connues, nous proposons seulement ce qui se fait de mieux ! En moyenne, le prix de ces modèles varie de 150€ à 200€.'
  },
  {
    number: 4,
    title: 'Les tests et l\'analyse',
    description: 'Ici, aucune chaussure n\'échappe au test de la piste : votre foulée est analysée sous tous les angles pour trouver la combinaison parfaite entre confort et stabilité. Grâce à la technologie Footscan combinée à l\'œil expert de votre conseiller et à votre ressenti sur le tartan, nous ajustons chaque détail. Vous courez, nous observons… et ensemble, nous trouvons la paire qui optimisera votre foulée en toute sécurité.'
  },
  {
    number: 5,
    title: 'Les dernières finitions',
    description: 'La bonne paire, c\'est bien. La bonne paire bien accompagnée, c\'est encore mieux ! 😉 Une semelle sur mesure, un laçage bien pensé, les chaussettes qui vont bien… Chaque détail compte pour accompagner votre foulée et révéler le meilleur de vos chaussures.'
  }
];

export const heroImages = {
  home: '/assets/images/hero-home.webp',
  lab: '/assets/images/hero-lab.jpg',
  chaussures: '/assets/images/banner-chaussures.webp',
  textile: '/assets/images/banner-textile.webp',
  accessoires: '/assets/images/hero-accessoires.jpg',
  nutrition: '/assets/images/banner-nutrition.jpg',
  equipe: 'https://images.unsplash.com/photo-1643727230494-84671df76705?w=1920&h=600&fit=crop',
  evenements: '/assets/images/hero-evenements.jpeg'
};

export const activities = ['TRAIL', 'ROUTE', 'TRIATHLON', 'SWIM & RUN', 'RANDONNÉE'];
